(function () {
    'use strict';

    angular
        .module('app.layout')
        .factory('filters.dialog', filterDialog);

    filterDialog.$inject = ['$uibModal', '$templateCache', 'opsIncludeVersion'];
    /* @ngInject */
    function filterDialog($modal, $templateCache, opsIncludeVersion) {
        var service = {
            display: display
        }
        
        $templateCache.put('filterDialog.tpl.html?v=' + opsIncludeVersion,
             '<div>' +
             '    <div class="modal-header">' +
             ' <div class="pull-right">' +
             '        <button class="btn btn-primary" data-ng-click="vm.ok()" data-ng-disabled="theForm.$invalid"><i class="fa fa-save"></i>{{vm.okText}}</button>' +
             '        <button class="btn btn-warning" data-ng-click="vm.cancel()"><i class="fa fa-undo"></i>{{vm.cancelText}}</button>' +
             ' </div>' +
             '        <h1 id="Filters">Filters</h1>' +
             '    </div>' +
             '    <div class="modal-body" ng-include="\'app/layout/_filters.html?v=' + opsIncludeVersion + '\'">' +
             '    </div>' +
             '    <div class="modal-footer">' +
                '        <button class="btn btn-primary" data-ng-click="vm.ok()" data-ng-disabled="theForm.$invalid"><i class="fa fa-save"></i>{{vm.okText}}</button>' +
                '        <button class="btn btn-warning" data-ng-click="vm.cancel()"><i class="fa fa-undo"></i>{{vm.cancelText}}</button>' +
                '    </div>' +
             '</div>');

        return service;


        function display() {
            var modalOptions = {
                ariaLabelledBy: "Filters",
                templateUrl: 'filterDialog.tpl.html?v=' + opsIncludeVersion,
                controller: FiltersModalInstance,
                controllerAs: 'vm',
                keyboard: true,
                size: 'lg'
            };

            return $modal.open(modalOptions).result;
        }
    }


    FiltersModalInstance.$inject = ['$uibModalInstance', 'common', 'dataservice', 'userService', 'config'];

        /* @ngInject */
    function FiltersModalInstance($modalInstance, common, dataservice, userService, config) {
        var vm = this;
        vm.okText = 'Apply';
        vm.cancelText = 'Cancel';
        vm.ok = applyFilter;
        vm.cancel = cancel;
        vm.selectedFilterData = {
            buildings: [],
            statuses: [],
            categories: [],
            roomTypes: [],
            eventTypes: [],
            views: [],
            udfs: [],
            highlightChangesWithin: 1440,
            includeBookingWithCategoriesOnly: 0,
            showReservedTimes: 1
        }
        vm.selectedFilterType = null;
        vm.Buildings = [];
        vm.Statuses = [];
        vm.Categories = [];
        vm.RoomTypes = [];
        vm.EventTypes = [];
        vm.Views = [];
        vm.Udfs = [];
        vm.filtersDisabled = filtersDisabled;
        vm.filterTypeChanged = filterTypeChanged;
        vm.showBuildingsFilter = true;
        vm.showViewsFilter = true;
        vm.showUdfsFilter = false;
        vm.eventTypeLabel = "Event Types";
        vm.categoryLabel = "Categories";
        vm.roomTypeLabel = "Room Types";
        vm.buildingsLabel = "Buildings";
        vm.udfsLabel = "UDFs";

        activate();

        function activate() {
            setDisplayForApiType();

            
            vm.selectedFilterData = userService.filterData();
            var promises = [getFilters(), getFilterTypes()];
            
            return common.$q.all(promises).then(function () {
                _validateFilters();
            }, function (error) { });
        }

        
        function applyFilter() {
            if (!vm.selectedFilterData.highlightChangesWithin || vm.selectedFilterData.highlightChangesWithin < 0) {
                common.logger.error("Highlight Changes Within must be greater than 0")
                return;
            }
            else {
                var updateDto = {
                    UserDefinedFilterData: null,
                    filterTypeId: vm.selectedFilterType.ID
                };
                
                if (vm.selectedFilterType.IsUserConfigurable) {
                    updateDto.UserDefinedFilterData = vm.selectedFilterData;
                    for (var i = 0; i < vm.filterTypes.length; i++) {
                        if (vm.filterTypes[i].ID == 0) {
                            vm.filterTypes[i].FilterData = btoa(angular.toJson(vm.filters))
                            break;
                        }
                    }
                }
                
                userService.saveUserConfigOptions(updateDto, vm.selectedFilterData);
                common.notifier.notify(config.events.userConfigOptionsChange);
                $modalInstance.close('ok');
            }
        }

        function setDisplayForApiType() {
            var apiType = userService.apiTypeId();
            switch (apiType) {
                case config.apiTypes.collegeNet:
                    vm.showViewsFilter = false;
                    vm.showUdfsFilter = true;
                    vm.eventTypeLabel = "Event Types";
                    vm.categoryLabel = "Resources Categories";
                    vm.roomTypeLabel = "Location Categories";
                    vm.buildingsLabel = "Location Partitions";
                    vm.udfsLabel = "Custom Attributes";
                    break;
                case config.apiTypes.sevenPoint:
                    vm.showUdfsFilter = true;
                    break;
                case config.apiTypes.mazevo:
                    vm.showViewsFilter = false;
                    vm.showUdfsFilter = false;
                    break;
            }
        }

        function filtersDisabled() {
            if (vm.selectedFilterType != null) {
                return vm.selectedFilterType.IsUserConfigurable == false;
            }
            return false;
        }

        function _validateFilters() {
            if (!vm.selectedFilterData) {
                vm.selectedFilterData = {
                    buildings: [],
                    statuses: [],
                    categories: [],
                    roomTypes: [],
                    eventTypes: [],
                    views: [],
                    udfs: [],
                    highlightChangesWithin: 1440,
                    includeBookingWithCategoriesOnly: 0,
                    showReservedTimes: 1
                }
            }
            if (!vm.selectedFilterData.roomTypes) {
                vm.selectedFilterData.roomTypes = [];
            }

            if (!vm.selectedFilterData.eventTypes) {
                vm.selectedFilterData.eventTypes = [];
            }

            if (!vm.selectedFilterData.buildings) {
                vm.selectedFilterData.buildings = [];
            }

            if (!vm.selectedFilterData.statuses) {
                vm.selectedFilterData.statuses = [];
            }

            if (!vm.selectedFilterData.categories) {
                vm.selectedFilterData.categories = [];
            }

            if (!vm.selectedFilterData.views) {
                vm.selectedFilterData.views = [];
            }

            if (!vm.selectedFilterData.udfs) {
                vm.selectedFilterData.udfs = [];
            }

            if (vm.selectedFilterData.showReservedTimes == undefined) {
                vm.selectedFilterData.showReservedTimes = true;
            }
            clean();

        }

        function clean() {
            vm.selectedFilterData.buildings = vm.selectedFilterData.buildings.filter(function (item) { return isIdInArray(item, vm.Buildings); });
            vm.selectedFilterData.statuses = vm.selectedFilterData.statuses.filter(function (item) { return isIdInArray(item, vm.Statuses); });
            vm.selectedFilterData.categories = vm.selectedFilterData.categories.filter(function (item) { return isIdInArray(item, vm.Categories); });
            vm.selectedFilterData.roomTypes = vm.selectedFilterData.roomTypes.filter(function (item) { return isIdInArray(item, vm.RoomTypes); });
            vm.selectedFilterData.eventTypes = vm.selectedFilterData.eventTypes.filter(function (item) { return isIdInArray(item, vm.EventTypes); });
            vm.selectedFilterData.views = vm.selectedFilterData.views.filter(function (item) { return isIdInArray(item, vm.Views); });
            vm.selectedFilterData.udfs = vm.selectedFilterData.udfs.filter(function (item) { return isIdInArray(item, vm.Udfs); });
        }

        function isIdInArray(item, selectedArray) {
            for (var i = 0; i < selectedArray.length; i++) {
                if (selectedArray[i].ID == item) {
                    return true;
                }
            }
            return false;
        }


        function filterTypeChanged(ft) {
            vm.selectedFilterType = ft;
            
            var fts = vm.filterTypes;
            for (var i = 0; i < fts.length; i++) {
                if (fts[i].ID == vm.selectedFilterType.ID) {
                    if (fts[i].IsUserConfigurable) {
                        var userConfigDto = angular.fromJson(atob(fts[i].FilterData));
                        vm.selectedFilterData = userConfigDto.UserDefinedFilterData;
                    }
                    else {
                        vm.selectedFilterData = angular.fromJson(atob(fts[i].FilterData));
                    }
                    break;
                }
            }
            
            _validateFilters();
            
        }


        function getFilterTypes() {
            dataservice.getItems('api/FilterTypes/ForUser/' + userService.userId()).then(function (response) {
                vm.filterTypes = response.data;
                var usersSelectedFilterTypeId = userService.filterTypeId();
                
                for (var i = 0; i < vm.filterTypes.length; i++) {
                    if (vm.filterTypes[i].ID == usersSelectedFilterTypeId) {
                        vm.selectedFilterType = vm.filterTypes[i];
                    }
                }
            }, function (error) {
                console.log("ERROR in getFilterTypes()", error);
            });
        }

        function cancel() {
            $modalInstance.dismiss('cancel');
        }

        function getFilters() {
            return dataservice.getItems('api/DailySetup/GetFilters').then(function (response) {
                var data = response.data;
                vm.Buildings = data.Buildings;
                vm.Statuses = data.Statuses;
                vm.Categories = data.Categories;
                vm.EventTypes = data.EventTypes;
                vm.RoomTypes = data.RoomTypes;
                vm.Views = data.Views;
                vm.Udfs = data.Udfs;

                return vm.selectedFilterData;
            }, function (error) {
                console.log("ERROR in getFilters()", error);
            });
        }
    }
})();
